<template>
  <div class="overflow-scroll-y">
    <div class="card">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>登録完了</h2>
          <p>
            yagiofferへのご登録ありがとうございました。<br />
            登録完了メールをお送りいたしましたのでご確認ください。
          </p>
          <div class="complete_block">
            <div class="cb-01">
              <h2 class="cb-h2">
                オファーがメール・<br />マイページで確認できます！
              </h2>

              <figure class="cb-figure">
                <img src="/static/renew3_img/yagioffer_complete_img.png" />
              </figure>
            </div>

            <!--転職用-->
            <div
              class="renew2_flex renew2_sp_flex cb-linkbox"
              v-if="formatId == 'career'"
            >
              <a
                href="/format/shokumukeirekisho/edit/profile"
                class="cb-linkitem cb-syokureki"
                >職歴書をつくる</a
              >
              <a href="/mypage/yagioffer" class="cb-linkitem cb-mypage"
                >マイページを見る</a
              >
            </div>
            <!--新卒用-->
            <div class="share_block" v-if="formatId == 'new'">
              <div class="cb-linkbox">
                <a href="/mypage/yagioffer" class="cb-linkitem cb-mypage"
                  >マイページを見る</a
                >
              </div>

              <h2>友だちにもシェア</h2>
              <div class="renew2_flex renew2_sp_flex yagioffe-share">
                <a
                  href="http://www.facebook.com/share.php?u=https://portal.yagish.jp/career_yagioffer/"
                  target="_blank"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share01.png"
                    alt="Facebookシェア"
                  />
                </a>
                <a
                  href="https://twiter.com/share?url=https://portal.yagish.jp/career_yagioffer/"
                  target="_blank"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share02.png"
                    alt="Xシェア"
                  />
                </a>
                <a
                  href="https://social-plugins.line.me/lineit/share?url=https://portal.yagish.jp/career_yagioffer/"
                  target="_blank"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share04.png"
                    alt="LINEシェア"
                  />
                </a>
                <a
                  href="javascript:navigator.clipboard.writeText('https://portal.yagish.jp/career_yagioffer/');alert('URLをコピーしました')"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share05.png"
                    alt="URLコピー"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="complete_block" v-if="false">
            <h2>yagiofferに登録したら…</h2>
            <div class="renew2_sp_flex yagioffer-flow">
              <img
                src="/static/renew2_img/yagioffer_img/offer01.png"
                alt="100ポイントが付与されます！"
                class="yagioffer-img"
              />
              <img
                src="/static/renew2_img/yagioffer_img/offer02.png"
                alt="届いたオファーを確認してチャットで連絡！"
                class="yagioffer-img"
              />
            </div>
            <p class="yagioffer-h3">届いたオファーを確認してチャットで連絡！</p>
            <div class="share_block">
              <p>＼yagiofferを友だちにシェア／</p>
              <div class="renew2_flex renew2_sp_flex yagioffe-share">
                <a
                  :href="facebook_portal_url"
                  rel="nofollow noopener"
                  class="share-btn"
                  target="_blank"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share01.png"
                    alt="Facebookシェア"
                /></a>
                <a :href="tw_portal_url" class="share-btn" target="_blank"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share02.png"
                    alt="Xシェア"
                /></a>
                <!--<a href="" class="share-btn" target="_blank"><img src="https://placehold.jp/100x100.png" alt="Instagramシェア"></a>-->
                <a
                  href="https://social-plugins.line.me/lineit/share?url=https://portal.yagish.jp/career_yagioffer/"
                  class="share-btn"
                  target="_blank"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share04.png"
                    alt="LINEシェア"
                /></a>
                <a
                  href="javascript:navigator.clipboard.writeText('https://portal.yagish.jp/career_yagioffer/');alert('URLをコピーしました')"
                  class="share-btn"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share05.png"
                    alt="URLコピー"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card .complete_block .cb-01 {
  background: #76ca80;
  border-radius: 10px;
  padding: 20px 20px 0;
  margin-top: 20px;
}

.card .complete_block .cb-h2 {
  text-align: center;
  color: #fff;
  line-height: 1.4;
}

.card .complete_block .cb-figure {
  margin: 0;
  text-align: center;
  margin-top: 15px;
}

.card .complete_block .cb-figure img {
  width: 255px;
}

.card .complete_block .cb-linkbox {
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
}

.card .complete_block .cb-linkitem {
  position: relative;
  width: calc(100% / 2 - 5px);
  text-align: center;
  background: #e95b10;
  border-radius: 50px;
  color: #fff;
  font-weight: bold;
  padding: 20px 0;
  line-height: 0;
}

.card .complete_block .cb-linkitem::after {
  position: absolute;
  content: '';
  width: 7px;
  height: 7px;
  border: 0;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 0;
  right: 8px;
  bottom: 0;
  margin: auto;
}

.card .complete_block .cb-mypage {
  background: #e3165c;
}

.card .complete_block .share_block {
  margin-top: 20px;
}

.card .complete_block .share_block .cb-linkitem {
  display: block;
  width: 100%;
}

.card .complete_block .yagioffe-share {
  justify-content: center;
  margin-top: 5px;
}

.card .complete_block .share-btn {
  width: 50px;
  margin-left: 10px;
}

.card .complete_block .share-btn:first-child {
  margin-left: 0;
}
</style>

<script>
import LoginForms from '@/components/LoginSpecialForms'
export default {
  props: {
    formatId: {
      type: String
    },
    isSendYagiPostEnabled: {
      type: Boolean
    },
    isSendYagiEmailEnabled: {
      type: Boolean
    },
    mailPdfEnabled: {
      type: Boolean
    },
    downloadPdfEnabled: {
      type: Boolean
    },
    downloadActiveCollapses: {
      type: Array
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    const app = this
    return {
      facebook_portal_url:
        'http://www.facebook.com/share.php?u=https://portal.yagish.jp/career_yagioffer/',
      tw_portal_url:
        'https://twiter.com/share?url=https://portal.yagish.jp/career_yagioffer/',
      isWeekEndFlag: true,
      errors: [],
      isMaint: false,
      isSendedYagishIntern: false,
      qemailBtnLabel: 'ポチッと企業に送信だメェ〜',
      qemailBtnLabels20231113: [
        'ポチッと企業に送信だメェ〜',
        '提出までやっちゃうメェ〜',
        '1クリックで送信だメェ〜',
        'メールで提出は任せろメェ〜',
        'メールで送信まで任せてメェ〜'
      ],
      qemailBtnLabels: [
        '簡単！セキュアな送信で応募完了！',
        '簡単！セキュアな送信で応募完了！',
        '1クリックで送信だメェ〜',
        '1クリックで送信だメェ〜',
        '簡単！セキュアな送信で応募完了！'
      ]
    }
  },
  created: function () {
    console.error(this.formatId)

    const nowdate = new Date()
    const date1 = new Date('2023/09/29 00:00:00')
    const date2 = new Date('2023/10/06 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    const date21 = new Date('2023/11/01 12:00:00')
    const date22 = new Date('2023/11/07 18:00:00')
    if (nowdate > date21 && nowdate < date22) {
      this.isMaint = true
    } else {
      this.isMaint = false
    }

    const nowdate2 = new Date()
    const date12 = new Date('2023/11/08 00:00:00')
    // const date2 = new Date('2023/10/26 02:00:00')
    /* 日時の差をミリ秒単位で取得 */
    const diffMilliSec = nowdate2 - date12
    /* ミリ秒を日数に変換 */
    const diffDays = parseInt(diffMilliSec / 1000 / 60 / 60 / 24)
    // console.error(diffDays)
    if (diffMilliSec < 0) {
      console.error(this.qemailBtnLabels[diffDays])
    } else if (diffDays > 4) {
      const _idx = diffDays % 5
      // console.error(_idx)
      // console.error(this.qemailBtnLabels[_idx])
      this.qemailBtnLabel = this.qemailBtnLabels[_idx]
    } else {
      // console.error(this.qemailBtnLabels[diffDays])
      this.qemailBtnLabel = this.qemailBtnLabels[diffDays]
    }
  },
  computed: {},
  methods: {
    alertMaint: function () {
      this.$message({
        message:
          '以下の日時においてヤギの宅配便サービスの休止を行います。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
        type: 'error'
      })
    }
  },
  beforeMount: function () {},
  mounted: function () {},
  destroyed: function () {}
}
</script>
